import { t } from 'typegate';
export const ParticipantRoles = {
    INSURED: 'INSURED',
    OWNER_PERSON: 'OWNER_PERSON',
    LEGAL_GUARDIAN: 'LEGAL_GUARDIAN',
    PAYER: 'PAYER',
    SECONDARY_PAYER: 'SECONDARY_PAYER',
    OWNER_ORGANIZATION: 'OWNER_ORGANIZATION',
    PRIMARY_BENEFICIARY: 'PRIMARY_BENEFICIARY',
    CONTINGENT_BENEFICIARY: 'CONTINGENT_BENEFICIARY',
    AGENT: 'AGENT',
    TRANSLATOR: 'TRANSLATOR',
    SIGNING_AUTHORITY: 'SIGNING_AUTHORITY',
    TRUSTEE: 'TRUSTEE',
    SOLE_PROPRIETOR: 'SOLE_PROPRIETOR',
    OFFICER: 'OFFICER',
    ANNUITANT: 'ANNUITANT',
    CONTRIBUTOR: 'CONTRIBUTOR',
    SECONDARY_CONTRIBUTOR: 'SECONDARY_CONTRIBUTOR',
};
export const participantRole = t.union(t.literal('INSURED'), t.literal('OWNER_PERSON'), t.literal('LEGAL_GUARDIAN'), t.literal('PAYER'), t.literal('SECONDARY_PAYER'), t.literal('OWNER_ORGANIZATION'), t.literal('PRIMARY_BENEFICIARY'), t.literal('CONTINGENT_BENEFICIARY'), t.literal('AGENT'), t.literal('TRANSLATOR'), t.literal('SIGNING_AUTHORITY'), t.literal('TRUSTEE'), t.literal('SOLE_PROPRIETOR'), t.literal('OFFICER'), t.literal('ANNUITANT'), t.literal('CONTRIBUTOR'), t.literal('SECONDARY_CONTRIBUTOR'));
